var FormType = {

     Unknown : 'Unknown'
    ,Survey  : 'Survey'
    ,Grid    : 'Grid'
}


module.exports = FormType;